<ng-template #confirm let-modal>
  <div *ngIf="headerMessage" class="modal-header pb-0">
    <div class="modal-title header with-underline">
      {{ headerMessage }}
    </div>
    <button type="button" class="close" (click)="modal.close(); onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body text-center h5 mt-3">
    {{ message }}
  </div>

  <div class="modal-footer">
    <button *ngIf="showCancel" class="btn btn-outline-danger" (click)="modal.close(); onClose()">Cancel</button>
    <button class="btn btn-danger" (click)="onConfirm()">Confirm</button>
  </div>
</ng-template>
